<div class="row">
    <span class="logo_area">
        <img src="assets/images/logo.png"
             class="logo"
             alt="logo"
             routerLink="/">
        <span class="env" *ngIf="envLabel()">{{envLabel()}}</span>
    </span>
    <span class="title">Admin Portal</span>
    <span *ngIf="!isLoggedIn()"></span>
    <button *ngIf="isLoggedIn()" mat-button (click)="logOut()">Log Out</button>
</div>

